import {Component, Injector, Input} from "@angular/core";
import {provideSearchModel} from "@fedeltapointofsale/data-client";
import {
    registerSelectEditControl
} from "../../../framework/entity/edit/edit-controls/select-edit-controls/abstract-select-edit-control.component";
import {
    AbstractSingleSelectEditControlComponent
} from "../../../framework/entity/edit/edit-controls/select-edit-controls/abstract-single-select-edit-control.component";
import {SizeGroupValuesSearchModel} from "../size-group-values-search.model";

@Component({
    selector: "wbo-size-group-values-single-select-edit-control",
    templateUrl: "../../../framework/entity/edit/edit-controls/select-edit-controls/single-select-edit-control.component.html",
    providers: [
        registerSelectEditControl(SizeGroupValuesSingleSelectEditControlComponent),
        provideSearchModel(SizeGroupValuesSearchModel)
    ]
})
export class SizeGroupValuesSingleSelectEditControlComponent extends AbstractSingleSelectEditControlComponent<SizeGroupValuesSearchModel> {
    private _sizeGroupId: number;

    constructor(model: SizeGroupValuesSearchModel, injector: Injector) {
        super(model, injector, "id", "name");
    }

    get sizeGroupId(): number {
        return this._sizeGroupId;
    }

    @Input()
    set sizeGroupId(value: number) {
        this._sizeGroupId = value;
        if (this._sizeGroupId) {
            this.model.filter["sizeGroupId"] = value;
            this.model.search().subscribe(() => this.data = this.model.data);
        }
    }


    get overrideLabel(): string {
        return this.labelField;
    }

    @Input()
    set overrideLabel(value: string) {
        this.labelField = value;
    }
}
